/** DataExtension のサブサービスに対応する組織ライセンス。 */
export const DATA_EXTENSION_LICENSES = {
  snapshot: 'snapshot',
  customObject: 'customObject',
  customColumn: 'customColumn',
} as const

/** SALESCORE 管理者が組織ごとに付与する組織ライセンスの名前 */
export const ORGANIZATION_LICENSES = {
  ...DATA_EXTENSION_LICENSES,
  customView: 'customView',
} as const

export type DataExtensionLicense = (typeof DATA_EXTENSION_LICENSES)[keyof typeof DATA_EXTENSION_LICENSES]

export type OrganizationLicense = (typeof ORGANIZATION_LICENSES)[keyof typeof ORGANIZATION_LICENSES]

/**
 * organization_plan.plan が取る値。契約形態を表すだけで、ライセンスの利用可否判定には使わない。
 * Prisma の OrganizationPlanType / GraphQL の OrganizationPlanTypeEnum と同じ 2 値。
 */
export const ORGANIZATION_PLANS = {
  free: 'free',
  standard: 'standard',
} as const

export type OrganizationPlan = (typeof ORGANIZATION_PLANS)[keyof typeof ORGANIZATION_PLANS]
